function getSessStorage(key) {
  return sessionStorage.getItem(key) || ""
}

function setSessStorage(key, value) {
  return sessionStorage.setItem(key, value)
}

function clearSessStorage(key) {
  return sessionStorage.removeItem(key)
}

export { getSessStorage, setSessStorage, clearSessStorage }